import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import { getGuideAccent } from "../../utils/guideAccent";

// Template328 (Edimburgo, copia de 128): Consejos útiles (Tips). Todo desde backend.
// page.texts[0]=header, [1]=intro | page.tips (icono, texto) | page.images (enchufe)
const Template328 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;
	const contentColor = textColor || "#444";

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found) return found.src ?? found.url;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found && found.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const headerText = page?.texts?.[0]?.content;
	const logoImage = page.canvasImages?.find(
		(img) => img.id === "logo",
	)?.imageUrl;
	const introText = page?.texts?.[1]?.content;
	const tips = Array.isArray(page?.tips)
		? page.tips
		: Array.isArray(page?.data?.tips)
			? page.data.tips
			: Array.isArray(page?.data?.data?.tips)
				? page.data.data.tips
				: [];
	const enchufeSticker =
		getImageSrc("enchufe") || getCanvasImageUrl("enchufe-sticker");

	const actualHeaderColor = headerBackgroundColor || "#de5624";
	const accent = getGuideAccent(actualHeaderColor);
	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: contentColor,
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
			}}
		>
			{headerText && (
				<Box
					data-block-id="header"
					data-template-header
					sx={{
						backgroundColor: actualHeaderColor,
						color: headerTextColor || "#fff",
						textAlign: "center",
						padding: "15px 0",
						fontSize: "14px",
						fontWeight: 600,
						flexShrink: 0,
						position: "sticky",
						top: 0,
						zIndex: 99999,
					}}
				>
					{headerText}
					{logoImage && !isSmallScreen && (
						<Box
							component="img"
							src={logoImage}
							alt="logo"
							sx={{
								width: isSmallScreen ? 66 : 80,
								position: "absolute",
								right: 2,
								top: 18,
								zIndex: 999999,
							}}
						/>
					)}
				</Box>
			)}

			{introText && (
				<Box
					data-block-id="text-1"
					sx={{ padding: "16px", fontSize: 13, color: contentColor }}
				>
					<Box component="p" sx={p}>
						{introText}
					</Box>
				</Box>
			)}

			<Box
				data-block-id="text-2"
				sx={{
					padding: "0 16px 20px",
					display: "flex",
					flexDirection: "column",
					gap: "12px",
					position: "relative",
					marginTop: introText ? 0 : 2,
				}}
			>
				{tips.map((tip, i) => (
					<Box
						key={tip.texto || i}
						sx={{
							backgroundColor: "#fff",
							borderRadius: "12px",
							padding: "12px 14px",
							display: "flex",
							alignItems: "center",
							gap: "10px",
							border: `2px solid ${accent.boxBg}`,
						}}
					>
						{tip.icono && <Box sx={{ fontSize: 18 }}>{tip.icono}</Box>}
						<Box sx={{ fontSize: 13, color: contentColor }}>
							{typeof tip.texto === "string" &&
							/<[a-z][\s\S]*>/i.test(tip.texto) ? (
								<Box
									component="span"
									dangerouslySetInnerHTML={{ __html: tip.texto }}
								/>
							) : (
								<>{tip.texto}</>
							)}
						</Box>
					</Box>
				))}
				{enchufeSticker && (
					<img
						src={enchufeSticker}
						alt=""
						style={{
							width: 100,
							position: "absolute",
							bottom: isSmallScreen ? -80 : -40,
							right: -20,
						}}
					/>
				)}
			</Box>
		</Box>
	);
};

Template328.thumbnail = "/images/template-1.png";

export default Template328;
